"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var kb_deserialization_helper_1 = require("./kb-deserialization-helper");
var from_1 = require("rxjs/observable/from");
var core_1 = require("@angular/core");
var KbService = /** @class */ (function () {
    function KbService(http, applicationPropertiesService) {
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.LOAD_CATEGORIES_WITH_PREFIX_URL = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/", "/categories"], ["", "/", "/categories"])), "serviceUri", "customPrefix");
        this.LOAD_CATEGORIES_URL = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", "/categories"], ["", "/categories"])), "serviceUri");
        this.serviceUrl = "kb-service-url";
        this.serviceUrl$ = from_1.from(this.applicationPropertiesService.getProperty(this.serviceUrl));
    }
    KbService.prototype.getMainEntityMetaCategories = function (customPrefix) {
        var _this = this;
        return this.serviceUrl$.flatMap(function (serviceUri) {
            var url;
            if (customPrefix == "de") {
                url = _this.LOAD_CATEGORIES_URL.replaceTemplate({
                    serviceUri: serviceUri,
                });
            }
            else {
                url = _this.LOAD_CATEGORIES_WITH_PREFIX_URL.replaceTemplate({
                    serviceUri: serviceUri,
                    customPrefix: customPrefix,
                });
            }
            return _this.http.get(url).map(function (response) {
                return kb_deserialization_helper_1.KbDeserializationHelper.extractMainCategories(response);
            });
        });
    };
    KbService.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    KbService.ctorParameters = function () { return [
        { type: idm_authentication_client_js_1.HttpClientWrapper, },
        { type: idm_application_properties_service_client_js_1.ApplicationPropertiesService, },
    ]; };
    return KbService;
}());
exports.KbService = KbService;
var templateObject_1, templateObject_2;
//# sourceMappingURL=kb.service.js.map